(() => {
  if (!customElements.get('product-promotion')) {
    customElements.define(
      'product-promotion',
      class ProductPromotion extends HTMLElement {
        constructor() {
          super();

          this.ready = false;

          if (typeof moment === 'function') {
            this.els();
            this.init();
          } else {
            const $script = document.createElement('script');
            $script.src = this.getAttribute('data-product-promotion-moment');
            $script.onload = () => {
              this.els();
              this.init();
            };
            document.head.appendChild($script);
          }

          window.addEventListener('collection.productPromotion', (e) => {
            if (this == e.detail) {
              this.updateMessages();
            }
          })
        };

        cookie = (name) => {
          let value = `; ${document.cookie}`;
          let parts = value.split(`; ${name}=`);
          if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
          return null;
        };

        els() {
          this.$dateFormat = 'MMMM D, YYYY hh:mm:ss a';
        };

        now() {
          return moment.tz(moment(), this.$dateFormat, productPromotionTimezone);
        };

        init() {
          this.ready = true;
          this.updateMessages();
        };

        removeHeight() {
          /* remove height holding space to fix layout shift when there's no message */
          document.documentElement.style.setProperty('--pdp-product-promotion-height', '0');
        };

        updateMessages() {
          if (!this.ready) return;

          if (typeof productPromotionData === 'undefined' || typeof productPromotionTimezone === 'undefined') {
            this.removeHeight();
            return;
          }

          let data = null;

          for (let i = 0; i < productPromotionData.length; ++i) {
            const preferredCurrency = this.cookie('preferred-currency') || window.Shopify.currency.active;
            if (productPromotionData[i].currencies && productPromotionData[i].currencies.includes(preferredCurrency)) {
              data = productPromotionData[i];

              const start = moment.tz(data.startDate, this.$dateFormat, productPromotionTimezone);
              const end = moment.tz(data.endDate, this.$dateFormat, productPromotionTimezone);

              /* Show messages if we are in the date range */
              if (moment(this.now()).isBetween(start, end)) {
                const $messageContainers = document.querySelectorAll('[data-product-promotion-message]');

                if (data.collectionIds.length < 1) {
                  data.collectionIds.push(data.collectionId);
                }

                $messageContainers.forEach(item => {
                  const container = item.closest('[data-product-promotion-container]');

                  if (!item.dataset.promotionPopulated) {
                    const collections = item.dataset.collectionIds.split(',');
                    const tags = item.dataset.tags.split(',');
                    const price = item.dataset.price;

                    if (data.mobileOnly) {
                      item.classList.add('product-promotion--mobile-only');
                    }

                    item.style.setProperty('--background-color', data.bg);
                    item.style.color = data.text;
                    if (container) {
                      container.classList.add('active');
                    }

                    /* If product is in collection show message */
                    const intersection = data.collections.filter(x => collections.includes(x));

                    /* Or if product has a tag */
                    const tagsIntersection = data.tags.filter(x => tags.includes(x));

                    if (intersection.length > 0 || tagsIntersection.length > 0) {
                      /* Calculate discounted promotional price */
                      const discountedPrice = price * ((100 - data.discount) / 100);
                      const amount = window.Shopify.formatMoney(discountedPrice, window.theme.moneyFormat || '${{amount}}');

                      /* Include price span that supports AU currency conversions */
                      const priceElement = `<span data-currency-conversion="${discountedPrice}">${amount}</span>`;

                      let message = data.message.replace('{amount}', priceElement);
                      message = message.replace('{code}', data.code);

                      if (data.note) {
                        message = `${message} <small>(${data.note})</small>`;
                      }

                      if (data.percentage != '' && document.body.classList.contains('template-collection')) {
                        let percentage = data.percentage.match(/{([^;]+)}/);

                        if (percentage && percentage[1]) {
                          const percent = Number(percentage[1]) / 100;
                          const percentagePrice = price * percent;
                          let salePrice = price - percentagePrice;
                          salePrice = window.Shopify.formatMoney(salePrice, window.theme.moneyFormat || '${{amount}}');
                          message = salePrice + data.percentage.replace(`{${Number(percentage[1])}}`, data.code);
                        }
                      }

                      let messageMarkup = '';
                      messageMarkup += '<span class="product-promotion__desktop-message-container">';
                      if (data.desktopLink) {
                        messageMarkup += `<a href="${data.desktopLink}">${message}</a>`;
                      } else {
                        messageMarkup += message;
                      }
                      messageMarkup += '</span>';

                      messageMarkup += '<span class="product-promotion__mobile-message-container">';
                      if (data.mobileLink) {
                        messageMarkup += `<a href="${data.mobileLink}">${message}</a>`;
                      } else {
                        messageMarkup += message;
                      }
                      messageMarkup += '</span>';

                      item.innerHTML = messageMarkup;
                      item.dataset.promotionPopulated = true;
                    } else {
                      if (container && container.classList.contains('active')) {
                        container.classList.remove('active');
                      }
                      item.innerHTML = '';
                      this.removeHeight();
                    }
                  }
                })
              } else {
                this.removeHeight();
              }
            }
          }

          if (!data) {
            this.removeHeight();
          }
        }
      }
    )
  }
})();
